import React from 'react';
import {Button} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSync} from '@fortawesome/pro-light-svg-icons';
import useTranslate from "../useTranslate";

interface Props {
    loading: boolean;
    onClick: () => void;
    showLabel?: boolean;
}

export default function RefreshButton(props: Readonly<Props>) {
    const {loading, onClick, showLabel = true} = props;
    const strings = useTranslate('General');
    const label = loading ? '...' : strings.refresh;

    return (
        <Button
            onClick={onClick}
            disabled={loading}
            style={{marginTop: '7px'}}
            className="btn btn-link btn-action"
        >
            <FontAwesomeIcon icon={faSync} className="icon-for-button"/>
            {showLabel ? label : null}
        </Button>
    );
}